import { render, staticRenderFns } from "./OrderViewActionsSpecCancelled.vue?vue&type=template&id=bd1ac7c8&"
import script from "./OrderViewActionsSpecCancelled.vue?vue&type=script&lang=js&"
export * from "./OrderViewActionsSpecCancelled.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports